let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iyupp")).then(() => parcelRequire('j4GZv'));